import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const StyledGrid = styled(Grid)({
  backgroundColor: "white",
  minWidth: 200,
  width: "fit-content",
  paddingBottom: 28,
});
